/* global jQuery */
import Fuse from 'fuse.js';

const replaceCdata = (str) => {
  let newStr = str.replace('<!--[CDATA[', '');
  newStr = newStr.replace(']]-->', '');
  return newStr;
};
class ProductSearch {
  constructor() {
    this.CLASSES = {
      bodyOpenClass: 'search-is-open',
      result: 'c-search-dropdown__result',
      resultsContainer: 'c-search-dropdown__results-container',
      searchInput: 'c-search-dropdown__input',
      openButton: 'c-header-link--search',
      openButtonOpenClass: 'open',
      searchDropdown: 'c-search-dropdown',
      openClass: 'c-search-dropdown--open',
      searchButton: 'c-search-dropdown__submit-button',
      archiveSearchButton: 'archive-search__button',
      archiveSearchInput: 'archive-search__input',
      searchClear: 'c-search-dropdown__clear',
      searchClose: 'c-search-dropdown__close',
    };
    this.DOM = {};

    this.init();
  }

  init() {
    this.DOM.body = document.querySelector('body');
    this.DOM.resultsContainer = document.querySelector(
      `.${this.CLASSES.resultsContainer}`,
    );
    this.DOM.searchInput = document.querySelector(
      `.${this.CLASSES.searchInput}`,
    );

    this.DOM.openButton = document.querySelector(`.${this.CLASSES.openButton}`);
    this.DOM.searchDropdown = document.querySelector(
      `.${this.CLASSES.searchDropdown}`,
    );
    this.DOM.searchButton = document.querySelector(
      `.${this.CLASSES.searchButton}`,
    );
    this.DOM.archiveSearchInput = document.querySelector(
      `.${this.CLASSES.archiveSearchInput}`,
    );
    this.DOM.archiveSearchButton = document.querySelector(
      `.${this.CLASSES.archiveSearchButton}`,
    );
    this.DOM.searchClear = document.querySelector(
      `.${this.CLASSES.searchClear}`,
    );
    this.DOM.searchClose = document.querySelector(
      `.${this.CLASSES.searchClose}`,
    );
    this.bindEvents();
  }

  bindEvents() {
    if (this.DOM.searchButton) {
      this.DOM.searchButton.addEventListener('click', () => {
        if (this.DOM.searchInput.value) {
          window.location.replace(
            `/?post_type=product&s=${this.DOM.searchInput.value}`,
          );
        }
      });
    }

    if (this.DOM.archiveSearchInput) {
      this.DOM.archiveSearchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          window.location.replace(
            `/?post_type=product&s=${this.DOM.archiveSearchInput.value}`,
          );
        }
      });
    }

    if (this.DOM.archiveSearchButton) {
      this.DOM.archiveSearchButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.DOM.archiveSearchInput.value) {
          window.location.replace(
            `/?post_type=product&s=${this.DOM.archiveSearchInput.value}`,
          );
        }
      });
    }

    if (this.DOM.searchInput) {
      const postUrl = (url) => {
        const parser = document.createElement('a');
        parser.href = url;
        return parser.pathname;
      };
      const searchFeed = `${window.location.origin}/wp-content/uploads/wp-fs/search-feed.xml`;
      jQuery.ajax(searchFeed, {
        accepts: {
          xml: 'application/rss+xml',
        },
        dataType: 'xml',
        success: (d) => {
          const searchArray = [];
          const data = d.getElementsByTagName('channel')[0];

          jQuery(data)
            .find('item')
            .each((i, e) => {
              const el = jQuery(e);
              const title = el.find('title').text();
              const status = el.find('wpstatus').text();
              let sku = '';

              if (!title || status !== 'publish') {
                return;
              }

              const meta = el.find('wp\\:postmeta');
              meta.each((m, postMeta) => {
                const j = jQuery(postMeta.innerHTML);
                if (j && j[0] && j[2]) {
                  const innerHtmlLabel = replaceCdata(
                    jQuery(j[0])[0].innerHTML,
                  );
                  if (innerHtmlLabel === '_sku') {
                    const innerHtmlSku = replaceCdata(
                      jQuery(j[2])[0].innerHTML,
                    );
                    sku = innerHtmlSku;
                  }
                }
                // const metaKey = postMeta.find('wp\\:meta_key');
                // if (metaKey.textContent === '_sku') {
                //   console.log(m, a, e);
                //   // el.children;
                // }
              });
              searchArray.push({
                status,
                title,
                description: el.find('excerpt\\:encoded').text(),
                content: el.find('content\\:encoded').text(),
                link: postUrl(el.find('link').text()),
                sku,
              });
            });

          const options = {
            shouldSort: true,
            threshold: 0.6,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: [
              {
                name: 'sku',
                weight: 0.75,
              },
              {
                name: 'title',
                weight: 0.75,
              },
              {
                name: 'description',
                weight: 0.5,
              },
              {
                name: 'content',
                weight: 0.5,
              },
            ],
          };

          const fuse = new Fuse(searchArray, options);
          this.DOM.searchInput.addEventListener('keyup', (e) => {
            const search = fuse.search(e.target.value);
            if (e.target.value.length > 0) {
              this.updateDOM(search);
            } else {
              this.updateDOM(null);
            }
          });
        },
      });
    }

    if (this.DOM.openButton) {
      this.DOM.openButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.DOM.openButton.classList.toggle(this.CLASSES.openButtonOpenClass);
        if (
          this.DOM.searchDropdown.classList.contains(this.CLASSES.openClass)
        ) {
          this.closeDropdown();
        } else {
          this.DOM.body.classList.add(this.CLASSES.bodyOpenClass);
          this.DOM.searchDropdown.classList.add(this.CLASSES.openClass);
          this.DOM.searchInput.focus();
          const event = new Event('onCloseMenu');
          document.dispatchEvent(event);
        }
      });
    }
    this.registerClickOutsideEvent();

    if (this.DOM.searchDropdown) {
      this.DOM.searchDropdown.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    if (this.DOM.searchClear) {
      this.DOM.searchClear.addEventListener('click', () => {
        this.DOM.searchInput.value = '';
        this.DOM.searchInput.focus();
        this.DOM.resultsContainer.innerHTML = '';
      });
    }

    if (this.DOM.searchClose) {
      this.DOM.searchClose.addEventListener('click', () => {
        this.closeDropdown();
      });
    }

    document.addEventListener('onCloseSearch', () => {
      this.closeDropdown();
    });
  }

  registerClickOutsideEvent() {
    const that = this;
    window.addEventListener('click', function outsideClickHandler() {
      if (that.DOM.searchDropdown.classList.contains(that.CLASSES.openClass)) {
        that.closeDropdown();
      }
    });
  }

  closeDropdown() {
    if (this.DOM.searchDropdown) {
      this.DOM.searchDropdown.classList.remove(this.CLASSES.openClass);
      this.DOM.openButton.classList.remove(this.CLASSES.openButtonOpenClass);
      setTimeout(() => {
        this.DOM.body.classList.remove(this.CLASSES.bodyOpenClass);
      }, 300);
    }
  }

  updateDOM(items) {
    this.DOM.resultsContainer.innerHTML = '';
    if (items == null) {
      return;
    }
    items.forEach((i) => {
      const { item } = i;
      const result = document.createElement('a');
      result.className = this.CLASSES.result;
      result.href = item.link;
      result.innerText = item.title;
      this.DOM.resultsContainer.append(result);
    });
    this.loading = false;
  }
}

export default () => {
  return new ProductSearch();
};
